import Cookies from "js-cookie";
import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AWS_URL } from "../../Constant";

const CreateStore = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    const formData = {
      Name: document.getElementById("Name").value,
      Address: document.getElementById("Address").value,
      Contact: document.getElementById("Contact").value,
      GST: document.getElementById("GST").value,
      state: document.getElementById("state").value,
      city: document.getElementById("city").value,
      RetailStoreCode: document.getElementById("RetailStoreCode").value,
      Products: [],
      Sales: [],
      // Products: document.getElementById("Products").value.split(",").map((item) => item.trim()),
      // Sales: document.getElementById("Sales").value.split(",").map((item) => item.trim()),
    };

    const jwtToken = Cookies.get("jwt_token");
    // const url ="https://ec2-13-235-112-81.ap-south-1.compute.amazonaws.com/createStoresAccount";
    const url = `${AWS_URL}/createStoresAccount`
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(formData),
    };

    try {
      setLoading(true);
      const response = await fetch(url, options);
      const data = await response.json();
      
      if (response.ok) {
        setSuccessMsg("Store created successfully!");
        // Clear all form fields
        document.getElementById("Name").value = "";
        document.getElementById("Address").value = "";
        document.getElementById("Contact").value = "";
        document.getElementById("GST").value = "";
        document.getElementById("state").value = "";
        document.getElementById("city").value = "";
        document.getElementById("RetailStoreCode").value = "";
        // Clear success message after 3 seconds
        setTimeout(() => setSuccessMsg(""), 3000);
      } else {
        setErrorMsg(data?.message || "Failed to create store");
      }
    } catch (error) {
      setErrorMsg(error?.message || "Error creating store. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const setTotalStocksOpen = () => {
    navigate("/admin");
  };

  return (
    <>
      <div className="flex flex-col h-[86vh]  justify-center rounded bg-zinc-200">
        <div className="flex justify-end p-2">
          <FaTimes
            className="text-rose-600 cursor-pointer  "
            onClick={() => setTotalStocksOpen()}
          />
        </div>
        <h1 className="text-xl text-center font-bold underline mb-5">
          Add New Store
        </h1>
        <form
          className="w-full flex flex-col items-center "
          onSubmit={handleFormSubmit}
        >
          <div className="flex mb-2 mt-2 space-x-4">
            <div className="w-80">
              <label htmlFor="Name">Name</label> <br />
              <input type="text" id="Name" className="   rounded-lg w-full" />
            </div>
            <div className="w-80">
              <label htmlFor="Address">Address</label> <br />
              <input
                type="text"
                id="Address"
                className="   rounded-lg w-full"
              />
            </div>
          </div>

          <div className="flex mb-2 mt-2 space-x-4">
            <div className="w-80">
              <label htmlFor="Contact">Contact</label> <br />
              <input
                type="text"
                id="Contact"
                className="rounded-lg w-full"
              />
            </div>

            <div className="w-80">
              <label htmlFor="GST">GST</label> <br />
              <input className=" rounded-lg w-full" type="text" id="GST" />
            </div>
          </div>

          <div className="flex mb-1 space-x-4 ">
            <div className="w-80">
              <label htmlFor="state">state</label> <br />
              <input className="rounded-lg w-full" type="text" id="state" />
            </div>

            <div className="w-80">
              <label htmlFor="city">city</label> <br />
              <input className="rounded-lg w-full" type="text" id="city" />
            </div>
          </div>

          <div className="flex mb-2 space-x-4 ">
            <div className="w-80 ">
              <label htmlFor="RetailStoreCode">RetailStoreCode</label> <br />
              <input
                className="   rounded-lg w-full"
                type="text"
                id="RetailStoreCode"
              />
            </div>
          </div>

          {successMsg && (
            <div className="bg-green-200 text-green-800 p-3 rounded mb-4 w-full text-center">
              {successMsg}
            </div>
          )}
          {errorMsg && (
            <div className="bg-red-200 text-red-800 p-3 rounded mb-4 w-full text-center">
              {errorMsg}
            </div>
          )}

          <div>
            <label htmlFor="submit"></label> <br />
            <input
              className="rounded-lg mb-1 font-bold disabled:opacity-50"
              type="submit"
              id="submit"
              value={loading ? "Submitting..." : "Submit"}
              disabled={loading}
            />
          </div>
        </form>
      </div>
    </>
  );
};

export default CreateStore;
